import { post } from '@utils/request';
import securityCheck from './securityCheck';

/* global ACTION_ROUTES */

export default function removePublishedChannel(action) {
  if (!securityCheck('Kanal wirklich entfernen?')) {
    return;
  }

  const jobId = action.getAttribute('data-job-id');
  const channelId = action.getAttribute('data-channel-id');
  const redirectUrl = action.getAttribute('data-redirect-url');

  if (!!channelId && !isNaN(jobId)) {
    post({
      url: ACTION_ROUTES.REMOVE_PUBLISHED_CHANNEL,
      data: {
        jobId: jobId,
        channelId: channelId,
      },
      success: data =>
        window.location.href === redirectUrl
          ? window.location.reload()
          : (window.location.href = redirectUrl),
    });
  }
}
